import { useMemo } from "react";

export interface PlannerSourceSettingsText {
  modeLabelText: string;
  myTasksLabelText: string;
  planTasksLabelText: string;
  planLabelText: string;
  planHintText: string;
  planPlaceholderText: string;
  bucketsLabelText: string;
  bucketsHintText: string;
  bucketsPlaceholderText: string;
  doneBucketLabelText: string;
  doneBucketHintText: string;
  doneBucketPlaceholderText: string;
  bucketForTaskCreationLabelText: string;
  bucketForTaskCreationHintText: string;
  bucketForTaskCreationPlaceholderText: string;
  assignedToMeLabelText: string;
  assignedToMeHintText: string;
  completeWhenDoneLabelText: string;
  completeWhenDoneHintText: string;
  loadingText: string;
  loadErrorText: string;
  bucketReferenceErrorText: string;
}

export const usePlannerSourceSettingsText = (
  t: (key: string) => string,
): PlannerSourceSettingsText => {
  return useMemo(() => {
    const tKey = (key: string): string =>
      t(`board.connections.dialog.sourceSettings.planner.${key}`);

    return {
      modeLabelText: tKey("modeLabel"),
      myTasksLabelText: tKey("myTasksLabel"),
      planTasksLabelText: tKey("planTasksLabel"),
      planLabelText: tKey("planLabel"),
      planHintText: tKey("planHint"),
      planPlaceholderText: tKey("planPlaceholder"),
      bucketsLabelText: tKey("bucketsLabel"),
      bucketsHintText: tKey("bucketsHint"),
      bucketsPlaceholderText: tKey("bucketsPlaceholder"),
      doneBucketLabelText: tKey("doneBucketLabel"),
      doneBucketHintText: tKey("doneBucketHint"),
      doneBucketPlaceholderText: tKey("doneBucketPlaceholder"),
      bucketForTaskCreationLabelText: tKey("bucketForTaskCreationLabel"),
      bucketForTaskCreationHintText: tKey("bucketForTaskCreationHint"),
      bucketForTaskCreationPlaceholderText: tKey(
        "bucketForTaskCreationPlaceholder",
      ),
      assignedToMeLabelText: tKey("assignedToMeLabel"),
      assignedToMeHintText: tKey("assignedToMeHint"),
      completeWhenDoneLabelText: tKey("completeWhenDoneLabel"),
      completeWhenDoneHintText: tKey("completeWhenDoneHint"),
      loadingText: tKey("loading"),
      loadErrorText: tKey("loadError"),
      bucketReferenceErrorText: tKey("bucketReferenceError"),
    };
  }, [t]);
};
